export enum MapBoxDrawEnum {
	DRAW_POLYGON = 'draw_polygon',
	DRAW_LINE_STRING = 'draw_line_string',
	SIMPLE_SELECT = 'simple_select',
}
